export default {
    strict: true,

    state: {
        auth_user:            {},
        app_url:              '',
        url_params:           '',
        current_dates:        {},
        date_format:          '',
        current_dwm:          {},
        hasFilters:           false,
        isArchive:            false,
        showQueries:          false,
        builder_popup_params: {},
        builder_elements:     []
    },

    mutations: {
        setAuthUser(state, user) {
            state.auth_user = user;
        },

        setAppUrl(state, url) {
            state.app_url = url;
        },

        setUrlParams(state, params){
            state.url_params = params
        },

        setCurrentDates(state, dates) {
            state.current_dates = dates;
        },

        setDateFormat(state, date_format) {
            state.date_format = date_format;
        },

        setCurrentDWM(state, dwm) {
            state.current_dwm = dwm;
        },

        setHasFilters(state, hasFilters) {
            state.hasFilters = hasFilters;
        },

        setIsArchive(state, isArchive) {
            state.isArchive = isArchive;
        },

        setShowQueries(state, showQueries) {
            state.showQueries = showQueries;
        },

        setBuilderPopupParams(state, payload) {
            state.builder_popup_params = payload;
        },

        addBuilderElement(state, payload) {
            state.builder_elements.push(payload);
        },

        setBuilderElements(state, payload) {
            state.builder_elements = payload;
        },

        updateBuilderElement(state, payload) {
            if (payload.name && payload.data) {
                const index = _.findIndex(state.builder_elements, {name: payload.name});
                if (index > -1) {
                    Vue.set(state.builder_elements, index, Object.assign(state.builder_elements[index], payload.data));
                }
            }
        },

        removeBuilderElement(state, payload) {
            const index = _.findIndex(state.builder_elements, {name: payload});

            if (index > -1) {
                state.builder_elements.splice(index, 1);
            }
        },

        resetBuilderData(state) {
            state.builder_elements = [];
        }
    },

    getters: {
        getAuthUser(state) {
            return state.auth_user;
        },

        getAppUrl(state) {
            return state.app_url;
        },

        getUrlParams(state) {
            return state.url_params;
        },

        getBuilderPopupParams(state) {
            return state.builder_popup_params;
        },

        getBuilderElements(state) {
            return state.builder_elements;
        }
    }
}
